/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  FIND_ASSIGNABLE_ASSETS_FOR_ACCOUNT,
  SortDirectionEnum,
} from '@gripp/shared-logic';
import { InfiniteDataGrid } from '@gripp/shared-ui';
import { ColumnDef } from '@tanstack/react-table';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAccountAssetColumns } from './useAccountAssetColumns';

type EditAccountAssetsListProps = {
  accountId: string;
  workspaceId: string;
  maxHeight?: number;
  keyword?: string;
  assignments: string[];
  updateAssignments: (assignments: string[]) => void;
};

export const EditAccountAssetsList = ({
  accountId,
  workspaceId,
  maxHeight,
  keyword,
  assignments,
  updateAssignments,
}: EditAccountAssetsListProps) => {
  const { t } = useTranslation();
  const [filter, setFilter] = useState<any>(() => ({
    accountId,
    workspaceId,
    keyword,
  }));
  const columns = useAccountAssetColumns() as ColumnDef<any, any>[];

  useEffect(() => {
    setFilter({ accountId, workspaceId, keyword });
  }, [accountId, workspaceId, keyword]);

  return (
    <InfiniteDataGrid
      modelName="asset"
      hideResultsLabel={true}
      query={FIND_ASSIGNABLE_ASSETS_FOR_ACCOUNT}
      filter={filter}
      pageSize={100}
      columns={columns}
      listMaxHeight={maxHeight as number}
      containerStyle={{ height: maxHeight }}
      paddingBottom={0}
      textEmpty={t('assets.textEmpty')}
      dataPrefix="asset.findAssignableAssetsForAccount"
      orderBy={{ field: 'name', order: SortDirectionEnum.Asc }}
      updateRowsSelected={(rows) => {
        updateAssignments(rows.map((row) => row.id));
      }}
      isRowSelected={(row) => {
        return assignments.includes(row.id) || row.isGroupAssigned;
      }}
      enableScrollRefresh={true}
      showScrollIndicator={true}
    />
  );
};
